<template>
    <div class="row items-stretch root full-height">
        <div class="col relative-position">
            <slot></slot>
            <DxfViewer ref="viewer" :dxfUrl="dxfUrl" :fonts="fonts"
                       @dxf-loaded="_OnLoaded" @dxf-cleared="_OnCleared" @dxf-message="_OnMessage" />
        </div>
        <div v-if="showLayers" class="col-auto layersCol">
            <LayersList :layers="layers" @toggleLayer="_OnToggleLayer" @toggleAll="_OnToggleAll"/>
        </div>
    </div>
</template>

<script>
import DxfViewer from "@/components/DxfViewer"
import {DxfViewer as _DxfViewer} from "dxf-viewer"
import Vue from "vue"

// 使用URL资源引用字体文件
const mainFont = "https://pub-ad78cd8d52c94cf2adf346f74f653c18.r2.dev/fonts/Roboto-LightItalic.ttf"
const aux1Font = "https://pub-ad78cd8d52c94cf2adf346f74f653c18.r2.dev/fonts/NotoSansDisplay-SemiCondensedLightItalic.ttf"
const aux2Font = "https://pub-ad78cd8d52c94cf2adf346f74f653c18.r2.dev/fonts/HanaMinA.ttf"
const aux3Font = "https://pub-ad78cd8d52c94cf2adf346f74f653c18.r2.dev/fonts/NanumGothic-Regular.ttf"
const myyhFont = "https://pub-ad78cd8d52c94cf2adf346f74f653c18.r2.dev/fonts/NotoSansSC-Regular.ttf"
import LayersList from "@/components/LayersList"

export default {
    name: "ViewerPage",
    components: {LayersList, DxfViewer},

    props: {
        dxfUrl: {
            type: String
        },
        showLayers: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            layers: null
        }
    },

    methods: {
        _OnLoaded() {
            const layers = this.$refs.viewer.GetViewer().GetLayers(true)
            layers.forEach(lyr => Vue.set(lyr, "isVisible", true))
            this.layers = layers
        },

        _OnCleared() {
            this.layers = null
        },

        _OnToggleLayer(layer, newState) {
            layer.isVisible = newState
            this.$refs.viewer.GetViewer().ShowLayer(layer.name, newState)
        },

        _OnToggleAll(newState) {
            if (this.layers) {
                for (const layer of this.layers) {
                    if (layer.isVisible !== newState) {
                        this._OnToggleLayer(layer, newState)
                    }
                }
            }
        },

        _OnMessage(e) {
            let type = "info"
            switch (e.detail.level) {
            case _DxfViewer.MessageLevel.WARN:
                type = "warning"
                break
            case _DxfViewer.MessageLevel.ERROR:
                type = "negative"
                break
            }
            this.$q.notify({ type, message: e.detail.message })
        }
    },

    created() {
        this.fonts = [mainFont, aux1Font, aux2Font, aux3Font, myyhFont]
    }
}
</script>

<style scoped lang="less">

.root {
    height: 100%;
    min-height: calc(100vh - 120px);
    
    .layersCol {
        border-left: #DBDBDB solid 1px;
        min-width: 250px;
    }
}

.full-height {
    height: 100%;
}

</style>
